/**
 * Freedom Community Page
 * Tab navigation + FAQ accordion
 */

(function() {
  'use strict';

  function initTabs() {
    const tabs = document.querySelectorAll('.freedom-community__tab');
    const panels = document.querySelectorAll('.freedom-community__tab-panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.getAttribute('data-tab');

        tabs.forEach(function(t) {
          const isActive = t === tab;
          t.classList.toggle('freedom-community__tab--active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function(panel) {
          const isMatch = panel.getAttribute('data-tab-content') === targetTab;
          panel.classList.toggle('freedom-community__tab-panel--hidden', !isMatch);
        });
      });
    });
  }

  function initFaq() {
    const faqQuestions = document.querySelectorAll('.freedom-community__faq-question[data-accordion-toggle]');

    faqQuestions.forEach(function(question) {
      const answer = question.nextElementSibling;
      if (answer && answer.hasAttribute('data-accordion-content')) {
        question.setAttribute('aria-expanded', 'false');
      }

      question.addEventListener('click', function(e) {
        e.preventDefault();
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const next = this.nextElementSibling;

        if (next && next.hasAttribute('data-accordion-content')) {
          this.setAttribute('aria-expanded', !isExpanded);
        }
      });
    });
  }

  function init() {
    initTabs();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
